
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { ClosedReasonOptions, ClosedReasonType } from '@/types';

@Component
export default class LeadCloseDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false
  loading = false

  selectedReason: ClosedReasonType | null = null;
  notes: string | null = null;

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.selectedReason = null;
      this.notes = null;
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (val === true) {
      this.$nextTick(() => {
        if (this.form) this.form.reset();
      });
    }

    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get reasonOptions() {
    return Object.entries(ClosedReasonOptions)
      .map((option) => ({ value: option[0], text: option[1] }));
  }

  get form(): Vue & { validate: () => boolean; reset: () => boolean } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  onCancel() {
    this.dialog = false;
  }

  async onClose() {
    if (this.form.validate()) {
      this.loading = true;

      await this.$store.dispatch('closeLead', {
        reason: this.selectedReason,
        notes: this.selectedReason === 'altro' ? this.notes : null,
      });

      this.dialog = false;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
}
